import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
    selector: "app-page-header",
    templateUrl: "./page-header.component.html",
    styleUrls: ["./page-header.component.scss"],
    standalone: false
})
export class PageHeaderComponent implements OnInit {
  private baseTitle = "ResolvED";

  @Input() pageTitle: string;

  @Input() helpLinks = false;

  @Input() viewReferral = false;

  @Input() viewEvaluation = false;

  @Input() isBold = true;

  @Input() showSubmitBtn = false;

  @Input() condensed = false;

  @Input() backgroundColor:
    | "red"
    | "yellow"
    | "blue"
    | "purple"
    | "white"
    | "primary"
    | "none" = "white";

  @Input() navBack = false;

  @Output() helpToggled = new EventEmitter();

  @Output() navBackToggled = new EventEmitter();

  @Output() submitToggled = new EventEmitter();

  @Output() viewReferralToggled = new EventEmitter();

  @Output() viewEvaluationToggled = new EventEmitter();

  constructor(private readonly title: Title) {}

  ngOnInit() {
    let newTitle = this.pageTitle;
    if (newTitle) {
      newTitle += ` - ${this.baseTitle}`;
    } else {
      newTitle = this.baseTitle;
    }
    this.title.setTitle(newTitle);
  }

  onHelpToggled(e: Event) {
    this.helpToggled.emit(e);
  }

  onNavBackToggled(e: Event) {
    this.navBackToggled.emit(e);
  }

  onSubmitToggled() {
    this.submitToggled.emit();
  }

  onViewReferralToggled(e: Event) {
    this.viewReferralToggled.emit(e);
  }

  onViewEvaluationToggled(e: Event) {
    this.viewEvaluationToggled.emit(e);
  }
}
